import React from 'react';
import { toast } from 'react-toastify';

import EcToast from './EcToast';

export const showToast = (
  type,
  text,
  href = null,
  autoCloseTime = undefined,
  isExternal = false,
  { closeButton, closeOnClick, theme } = {},
) => {
  const resolvedText = text ?? '';
  toast(
    <EcToast
      type={type}
      text={resolvedText}
      href={href}
      isExternal={isExternal}
    />,
    {
      autoClose: autoCloseTime,
      closeButton,
      closeOnClick,
      theme,
    },
  );
};
